import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import {
  BulkEditEffects,
  SurveyEffects,
  ManageSurveyEffects,
  SurveyReferenceEffects,
  SurveySocketEffects,
  SurveyActivityLogEffects,
  SupplierEffects,
  surveyFeature,
} from './state';

export const SURVEY_STORE_PROVIDERS = {
  feature: provideState(surveyFeature),
  effects: provideEffects(
    SurveyEffects,
    BulkEditEffects,
    SurveyReferenceEffects,
    ManageSurveyEffects,
    SurveySocketEffects,
    SurveyActivityLogEffects,
    SupplierEffects,
  ),
};
